import { render, staticRenderFns } from "./button-back.vue?vue&type=template&id=597ca90d&scoped=true"
import script from "./button-back.vue?vue&type=script&lang=ts"
export * from "./button-back.vue?vue&type=script&lang=ts"
import style0 from "./button-back.vue?vue&type=style&index=0&id=597ca90d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597ca90d",
  null
  
)

export default component.exports